import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { QrCode, ExternalLink, AlertCircle } from 'lucide-react';
import axiosInstance from '../utils/axios';

interface RedirectData {
  longUrl: string;
  shortCode: string;
  clicks?: number;
}

const RedirectHandler: React.FC = () => {
  const { shortCode } = useParams<{ shortCode: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [redirectUrl, setRedirectUrl] = useState<string>('');

  // useEffect(() => {
  //   const fetchAndRedirect = async () => {
  //     if (!shortCode) {
  //       navigate('/');
  //       return;
  //     }

  //     try {
  //       setIsLoading(true);

  //       // Call your backend API to get the long URL
  //       const response = await axiosInstance.get<RedirectData>(`/api/QRShortLinkRedirect/${shortCode}`);

        
  //       const { longUrl } = response.data;

  //       if (longUrl) {
  //         setRedirectUrl(longUrl);
          
  //         // Small delay to show the redirect screen (optional)
  //         setTimeout(() => {
  //           // Redirect to the long URL
  //           window.location.href = longUrl;
  //         }, 500);
  //       } else {
  //         setError('Invalid link');
  //         setIsLoading(false);
  //       }

  //     } catch (err: any) {
  //       setIsLoading(false);
        
  //       if (err.response?.status === 404) {
  //         setError('Link not found. This short link may have expired or been deleted.');
  //       } else if (err.response?.status === 410) {
  //         setError('This link has expired.');
  //       } else {
  //         setError('Unable to redirect. Please try again later.');
  //       }
        
  //       console.error('Redirect error:', err);
  //     }
  //   };

  //   fetchAndRedirect();
  // }, [shortCode, navigate]);


// useEffect(() => {
//   const fetchAndRedirect = async () => {
//     if (!shortCode) {
//       navigate('/');
//       return;
//     }

//     try {
//       setIsLoading(true);

//       // ✅ Step 1: Get user's real IP address first
//       let clientIp = 'Unknown';
//       try {
//         const ipResponse = await fetch('https://api.ipify.org?format=json');
//         const ipData = await ipResponse.json();
//         clientIp = ipData.ip;
//         console.log('Client IP captured:', clientIp);
//       } catch (ipError) {
//         console.warn('Could not fetch client IP, continuing anyway:', ipError);
//         // Continue with request even if IP fetch fails
//       }

//       // ✅ Step 2: Call your backend API with the client IP
//       const response = await axiosInstance.get<RedirectData>(
//         `/api/QRShortLinkRedirect/${shortCode}`,
//         {
//           headers: {
//             'X-Client-IP': clientIp, // Pass real IP to backend
//           },
//         }
//       );

//       const { longUrl } = response.data;

//       if (longUrl) {
//         setRedirectUrl(longUrl);
        
//         // Small delay to show the redirect screen
//         setTimeout(() => {
//           // Redirect to the long URL
//           window.location.href = longUrl;
//         }, 500);
//       } else {
//         setError('Invalid link');
//         setIsLoading(false);
//       }

//     } catch (err: any) {
//       setIsLoading(false);
      
//       if (err.response?.status === 404) {
//         setError('Link not found. This short link may have expired or been deleted.');
//       } else if (err.response?.status === 410) {
//         setError('This link has expired.');
//       } else {
//         setError('Unable to redirect. Please try again later.');
//       }
      
//       console.error('Redirect error:', err);
//     }
//   };

//   fetchAndRedirect();
// }, [shortCode, navigate]);  

useEffect(() => {
  const fetchAndRedirect = async () => {
    if (!shortCode) {
      navigate('/');
      return;
    }

    try {
      setIsLoading(true);

      // ✅ Fetch IP once
      let clientIp = 'Unknown';
      
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json', {
          method: 'GET',
          signal: AbortSignal.timeout(3000)
        });
        
        if (ipResponse.ok) {
          const ipData = await ipResponse.json();
          clientIp = ipData.ip || 'Unknown';
          
          // ✅ CRITICAL: Ensure single IP (in case API returns comma-separated)
          if (clientIp.includes(',')) {
            //console.warn('IP contains comma, taking first value');
            clientIp = clientIp.split(',')[0].trim();
          }
          
          //console.log('✅ Clean IP to send:', clientIp);
        }
      } catch (ipError) {
        //console.error('Could not fetch IP:', ipError);
      }

      // ✅ Send clean IP to backend
      const response = await axiosInstance.get<RedirectData>(
        `/api/QRShortLinkRedirect/${shortCode}`,
        {
          headers: {
            'X-Client-IP': clientIp, // Guaranteed single IP
          },
        }
      );

      const { longUrl } = response.data;

      if (longUrl) {
        setRedirectUrl(longUrl);
        setTimeout(() => {
          window.location.href = longUrl;
        }, 500);
      } else {
        setError('Invalid link');
        setIsLoading(false);
      }

    } catch (err: any) {
      setIsLoading(false);
      
      if (err.response?.status === 404) {
        setError('Link not found. This short link may have expired or been deleted.');
      } else if (err.response?.status === 410) {
        setError('This link has expired.');
      } else {
        setError('Unable to redirect. Please try again later.');
      }
      
      //console.error('Redirect error:', err);
    }
  };

  fetchAndRedirect();
}, [shortCode, navigate]);

  // Loading state
  if (isLoading && !error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl mb-6 animate-pulse">
            <ExternalLink className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Redirecting...</h2>
          <p className="text-gray-300 mb-4">Taking you to your destination</p>
          {redirectUrl && (
            <p className="text-sm text-gray-400 break-all max-w-md mx-auto">
              {redirectUrl}
            </p>
          )}
          <div className="flex justify-center gap-2 mt-6">
            <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-3 h-3 bg-pink-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-500/10 border border-red-500/20 rounded-2xl mb-6">
            <AlertCircle className="w-10 h-10 text-red-400" />
          </div>
          
          <h2 className="text-2xl font-bold text-white mb-3">Link Not Found</h2>
          <p className="text-gray-300 mb-6">{error}</p>
          
          <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-gray-400 mb-2">Short Code:</p>
            <p className="text-white font-mono break-all">{shortCode}</p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-lg font-medium hover:shadow-lg hover:shadow-purple-500/50 transition flex items-center justify-center"
          >
            <QrCode className="w-5 h-5 mr-2" />
            Go to Homepage
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default RedirectHandler;